import { render, staticRenderFns } from "./information-card.vue?vue&type=template&id=8d5f6c98"
import script from "./information-card.vue?vue&type=script&lang=js"
export * from "./information-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports